"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityInterestedNurseDtoFormVersionEnum = void 0;
exports.instanceOfFacilityInterestedNurseDto = instanceOfFacilityInterestedNurseDto;
exports.FacilityInterestedNurseDtoFromJSON = FacilityInterestedNurseDtoFromJSON;
exports.FacilityInterestedNurseDtoFromJSONTyped = FacilityInterestedNurseDtoFromJSONTyped;
exports.FacilityInterestedNurseDtoToJSON = FacilityInterestedNurseDtoToJSON;
exports.FacilityInterestedNurseDtoToJSONTyped = FacilityInterestedNurseDtoToJSONTyped;
const InterestWorkType_1 = require("./InterestWorkType");
const TravelWillingness_1 = require("./TravelWillingness");
const NurseSpecialtyDto_1 = require("./NurseSpecialtyDto");
const ContactPreference_1 = require("./ContactPreference");
const InterestShiftLength_1 = require("./InterestShiftLength");
const InterestAvailability_1 = require("./InterestAvailability");
const InterestShiftType_1 = require("./InterestShiftType");
const WorkTypePreference_1 = require("./WorkTypePreference");
/**
 * @export
 */
exports.FacilityInterestedNurseDtoFormVersionEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
};
/**
 * Check if a given object implements the FacilityInterestedNurseDto interface.
 */
function instanceOfFacilityInterestedNurseDto(value) {
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    if (!('specialties' in value) || value['specialties'] === undefined)
        return false;
    if (!('formVersion' in value) || value['formVersion'] === undefined)
        return false;
    if (!('workTypePreference' in value) || value['workTypePreference'] === undefined)
        return false;
    if (!('willingToTravel' in value) || value['willingToTravel'] === undefined)
        return false;
    if (!('interestSpecialtyCodes' in value) || value['interestSpecialtyCodes'] === undefined)
        return false;
    if (!('workTypes' in value) || value['workTypes'] === undefined)
        return false;
    if (!('workTypeOther' in value) || value['workTypeOther'] === undefined)
        return false;
    if (!('shiftTypes' in value) || value['shiftTypes'] === undefined)
        return false;
    if (!('shiftTypeOther' in value) || value['shiftTypeOther'] === undefined)
        return false;
    if (!('shiftLengths' in value) || value['shiftLengths'] === undefined)
        return false;
    if (!('availability' in value) || value['availability'] === undefined)
        return false;
    if (!('availabilityOther' in value) || value['availabilityOther'] === undefined)
        return false;
    if (!('minimumRate' in value) || value['minimumRate'] === undefined)
        return false;
    if (!('contactPreference' in value) || value['contactPreference'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('archivedAt' in value) || value['archivedAt'] === undefined)
        return false;
    if (!('isProfileComplete' in value) || value['isProfileComplete'] === undefined)
        return false;
    return true;
}
function FacilityInterestedNurseDtoFromJSON(json) {
    return FacilityInterestedNurseDtoFromJSONTyped(json, false);
}
function FacilityInterestedNurseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfileId': json['nurseProfileId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'avatar': json['avatar'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'resumeUrl': json['resumeUrl'] == null ? undefined : json['resumeUrl'],
        'specialties': (json['specialties'].map(NurseSpecialtyDto_1.NurseSpecialtyDtoFromJSON)),
        'formVersion': json['formVersion'],
        'workTypePreference': (0, WorkTypePreference_1.WorkTypePreferenceFromJSON)(json['workTypePreference']),
        'willingToTravel': (0, TravelWillingness_1.TravelWillingnessFromJSON)(json['willingToTravel']),
        'interestSpecialtyCodes': json['interestSpecialtyCodes'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'startDateComment': json['startDateComment'] == null ? undefined : json['startDateComment'],
        'workTypes': (json['workTypes'].map(InterestWorkType_1.InterestWorkTypeFromJSON)),
        'workTypeOther': json['workTypeOther'],
        'shiftTypes': (json['shiftTypes'].map(InterestShiftType_1.InterestShiftTypeFromJSON)),
        'shiftTypeOther': json['shiftTypeOther'],
        'shiftLengths': (json['shiftLengths'].map(InterestShiftLength_1.InterestShiftLengthFromJSON)),
        'availability': (0, InterestAvailability_1.InterestAvailabilityFromJSON)(json['availability']),
        'availabilityOther': json['availabilityOther'],
        'minimumRate': json['minimumRate'],
        'contactPreference': (0, ContactPreference_1.ContactPreferenceFromJSON)(json['contactPreference']),
        'createdAt': (new Date(json['createdAt'])),
        'archivedAt': (json['archivedAt'] == null ? null : new Date(json['archivedAt'])),
        'isProfileComplete': json['isProfileComplete'],
    };
}
function FacilityInterestedNurseDtoToJSON(json) {
    return FacilityInterestedNurseDtoToJSONTyped(json, false);
}
function FacilityInterestedNurseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfileId': value['nurseProfileId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'avatar': value['avatar'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'resumeUrl': value['resumeUrl'],
        'specialties': (value['specialties'].map(NurseSpecialtyDto_1.NurseSpecialtyDtoToJSON)),
        'formVersion': value['formVersion'],
        'workTypePreference': (0, WorkTypePreference_1.WorkTypePreferenceToJSON)(value['workTypePreference']),
        'willingToTravel': (0, TravelWillingness_1.TravelWillingnessToJSON)(value['willingToTravel']),
        'interestSpecialtyCodes': value['interestSpecialtyCodes'],
        'comment': value['comment'],
        'startDateComment': value['startDateComment'],
        'workTypes': (value['workTypes'].map(InterestWorkType_1.InterestWorkTypeToJSON)),
        'workTypeOther': value['workTypeOther'],
        'shiftTypes': (value['shiftTypes'].map(InterestShiftType_1.InterestShiftTypeToJSON)),
        'shiftTypeOther': value['shiftTypeOther'],
        'shiftLengths': (value['shiftLengths'].map(InterestShiftLength_1.InterestShiftLengthToJSON)),
        'availability': (0, InterestAvailability_1.InterestAvailabilityToJSON)(value['availability']),
        'availabilityOther': value['availabilityOther'],
        'minimumRate': value['minimumRate'],
        'contactPreference': (0, ContactPreference_1.ContactPreferenceToJSON)(value['contactPreference']),
        'createdAt': ((value['createdAt']).toISOString()),
        'archivedAt': (value['archivedAt'] == null ? null : value['archivedAt'].toISOString()),
        'isProfileComplete': value['isProfileComplete'],
    };
}
//# sourceMappingURL=FacilityInterestedNurseDto.js.map